import React, { useState } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import styled from 'styled-components';

const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;
`;

const TooltipContent = styled.div`
  position: absolute;
  bottom: calc(100% + 8px);
  right: 80%;
  transform: translateX(10%);
  width: 400px;  
  background-color: rgba(0, 0, 0, 0.9);
  color: white;
  padding: 12px;
  border-radius: 4px;
  white-space: normal;
  overflow-wrap: break-word;
  text-align: left;
  z-index: 999;
  visibility: ${props => (props.$visible ? 'visible' : 'hidden')};
  opacity: ${props => (props.$visible ? 1 : 0)};
  transition: opacity 0.2s ease-in-out;
  font-size: 1.2rem;
  font-weight: 400;

  &::after {
    content: '';
    position: absolute;
    top: 100%;
    right: 8%;
    transform: translateX(-50%);
    border-width: 6px;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.85) transparent transparent transparent;
  }
`;

const CustomToolTip = (props) => {
    const [visible, setVisible] = useState(false);

  return (
    <TooltipWrapper
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {props.children}
        <TooltipContent $visible={visible}>
            {props.caption}
        </TooltipContent>
    </TooltipWrapper>
  );
};

export default CustomToolTip;
